// ACEPTA /{slug} SOLO SI NO ES RESERVADO (sin llamadas HTTP aquí)
import { UrlMatcher, UrlSegment, UrlSegmentGroup, Route } from '@angular/router';

const reserved = new Set([
  'login', 'account', 'identity', 'tenant-management', 'setting-management',
  'wineries', 'sommeliers', 'wines'
]);

export const slugMatcher: UrlMatcher = (
  segments: UrlSegment[],
  _group: UrlSegmentGroup,
  _route: Route
) => {
  // Debe ser exactamente un segmento
  if (segments.length !== 1) return null;

  // Tomamos el primer segmento de la URL completa
  const firstSegment = window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase() ?? '';
  const slug = (segments[0]?.path ?? '').trim().toLowerCase();
  if (!firstSegment || reserved.has(firstSegment)) return null;

  // Creamos un UrlSegment artificial para exponerlo como parámetro
  const slugSegment = new UrlSegment(firstSegment, {});

  // Aceptamos la URL y exponemos el slug como parámetro de ruta
  return {
    consumed: segments,
    posParams: { slug: slugSegment },
  };
};
